import script from "./TransitionVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionVideo.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionVideo.vue?vue&type=style&index=0&id=09f07d7e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f07d7e"]])

export default __exports__